export interface MarkerStyleEntity {
  specificId: string;
  image: string;
  imageNumber: number;
  imgBase64List: string[];
  iconFieldType?: string;
  iconNumberRanges?: number[];
}
